import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const ffSection = document.querySelectorAll('.related-content-cards-section');

    ffSection.forEach(section => {
        const facilitiesSldier = section.querySelector('.rccs-slider'); // Make sure to scope this to each section

        new Swiper(facilitiesSldier, {
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                prevEl: section.querySelector('.rccs-arrow-prev'),
                nextEl: section.querySelector('.rccs-arrow-next'),
            },
            breakpoints: {
                576: {
                    slidesPerView: 1.5,
                },
                767: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });
    });
});
